import React from 'react'
import { Link } from 'react-router-dom'
import MessageUtils from '../../../util/MessageUtils'
import './ProjectAvatarList.css'

const ProjectAvatarListUI = ({context, messageList, project, projectUserList, assigneeFilter, onAssigneeFilterClick}) =>
  <div className='c_prj_ava'>
      {
        projectUserList && projectUserList.filter(projectUser => projectUser.roleId !== null).map((projectUser, i) =>
          <img key={i} alt=''
            src={projectUser.avatarUrl}
            className={projectUser.userId === assigneeFilter ? 'selected' : ''}
            onClick={onAssigneeFilterClick}
            data-user-id={projectUser.userId}
            data-tip={projectUser.name}
          />
        )
      }
      {
        project &&
        <Link to={`/projects/${project.projectId}/users`} className='icon icon-user-plus'
          data-tip={MessageUtils.getMessageValue(messageList, 'c_project_users')}
        />
      }
  </div>

export default ProjectAvatarListUI
